'use strict';

// Feature Collection Slider =================================================================
var featured_collection_slider = new Swiper('.featured_collection_slider', {
    slidesPerView: 1.05,
    spaceBetween: 14,
    speed: 500,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
       400: {
            slidesPerView: 1.15,
            spaceBetween: 14,
        },
        576: {
            slidesPerView: 1.7,
            spaceBetween: 14,
        },
        768: {
            slidesPerView: 2.2,
            spaceBetween: 14,
        },
        992: {
            slidesPerView: 2.5,
            spaceBetween: 14,
        },
        1200: {
            slidesPerView: 3,
            spaceBetween: 15,
        },
        1500: {
            slidesPerView: 4,
            spaceBetween: 15,
        },
        1800: {
            slidesPerView: 4,
            spaceBetween: 20,
        },
    },
});
// 
  //  var featured_collection_slider_v2  = new Swiper('.template_product-v2 .featured_collection_slider ', {
  //           slidesPerView: 1.05,
  //           spaceBetween: 14,
  //           speed: 500,
  //           navigation: {
  //               nextEl: ".swiper-button-next",
  //               prevEl: ".swiper-button-prev",
  //           },
  //           breakpoints: {
  //               400: { slidesPerView: 1.15, spaceBetween: 14 },
  //               576: { slidesPerView: 1.7,   spaceBetween: 14 },
  //               768: { slidesPerView: 2.2,   spaceBetween: 14 },
  //               992: { slidesPerView: 2.5,   spaceBetween: 14 },
  //               1200:{ slidesPerView: 3,     spaceBetween: 15 },
  //               1300:{ slidesPerView: 3.5,   spaceBetween: 15 },
  //               1600:{ slidesPerView: 4.01,  spaceBetween: 15 },
  //               1800:{ slidesPerView: 3.98,  spaceBetween: 16 },
  //           },
  //       });
// 
var testimonialSlider = new Swiper('.pl_products_slider', {
    slidesPerView: 1.1,
    spaceBetween: 15,
    speed: 400,
    breakpoints: {
        400 : {
            slidesPerView: 1.31,
            spaceBetween: 24,
        },
        576: {
            slidesPerView: 1.7,
            spaceBetween: 24,
        },
        768: {
            slidesPerView: 2.5,
            spaceBetween: 24,
        },
        1200: {
            slidesPerView: 4,
            spaceBetween: 20,
        },
        1600: {
            slidesPerView: 4,
            spaceBetween: 30,
        },
        1800: {
            slidesPerView: 4,
            spaceBetween: 48,
        },
    },
});
// Information Slider ========================================================================
var info_slider = new Swiper('.info_slider', {
    slidesPerView: 1,
    spaceBetween: 50,
    speed: 1500,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
     breakpoints: {
      0: {
          autoHeight: true, // Enable autoHeight
      },
      992: {
          autoHeight: false, // Enable autoHeight
      },
     },
});
// Product Slider ========================================================================
// var gallerySwiper = new Swiper('.main_pdp_slider', {
//   loop: false,
//   slidesPerView: 1,
//   spaceBetween: 15,
//   speed: 500,
//   pagination: {
//     el: '.swiper-pagination',
//     clickable: true
//   },
//   navigation: {
//         nextEl: ".swiper-button-next",
//         prevEl: ".swiper-button-prev",
//     },
// });
// Testimonial =============================================================================
  var testimonial_slider = new Swiper(".testimonial_slider", {
      slidesPerView: 1.1,
      spaceBetween: 10,
      speed: 500,
      navigation: {
        nextEl: ".testimonial_slider .swiper-button-next",
        prevEl: ".testimonial_slider .swiper-button-prev",
    },
      breakpoints: {
        400: {
        slidesPerView: 1.28,
       spaceBetween: 15,
        },
        576: {
          slidesPerView: 1.5,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1600: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      },
    });
// PDP V2 Retailer slider =========================================================================
  var swiper = new Swiper(".our_retailers_slider", {
  slidesPerView: 'auto',
  spaceBetween: 24,
  speed: 500,
   breakpoints: {
    1800: {
      slidesPerView: 'auto',
      spaceBetween: 36,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
// Timeline slider =================================================================================
  var timeline_slider = new Swiper(".timeline_slider", {
     speed: 3000,
     autoplay: {
          delay: 8000,
          waitForTransition: true, 
        },
      // autoplay: true,
      autoHeight: false,
      spaceBetween: 30,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      loop: true,
    });


// Target the container so animation fires only when this section is visible =================
document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector('.image_text_container');

  // Exit early if the section is not on the page
  if (!container) return;

  const imagesToPop = container.querySelectorAll('.itc_image_one, .itc_image_two');

  // Exit if no target images exist
  if (!imagesToPop.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          imagesToPop.forEach((img) => img.classList.add('active'));
          observer.unobserve(entry.target); // run once
        }
      });
    },
    { threshold: 0.3 }
  );

  observer.observe(container);
});

// Quilton Club : Steps JS ====================================================================
document.addEventListener("DOMContentLoaded", () => { 
  /* ------------------------------------------
      1) SHOW FIRST-VISIT MODAL AFTER 5 SECONDS
  ------------------------------------------ */

  // Only show once per user
  if (!localStorage.getItem("enter_draw_shown")) {
      setTimeout(() => {
          const enterModalEl = document.getElementById("enterTheDraw");
          if (enterModalEl) {
              const enterModal = new bootstrap.Modal(enterModalEl);
              enterModal.show();

              // Save flag so it won't show again
              localStorage.setItem("enter_draw_shown", "1");
          }
      }, 5000);
  }

  /* ------------------------------------------
      2) OPEN drawPopup WHEN BUTTON IS CLICKED
  ------------------------------------------ */

  const openBtn = document.querySelector("#enterTheDraw .btn-light");
  if (openBtn) {
      openBtn.addEventListener("click", () => {

          const drawEl = document.getElementById("drawPopup");
          if (!drawEl) return;

          // Close the first modal
          const enterModal = bootstrap.Modal.getInstance(document.getElementById("enterTheDraw"));
          if (enterModal) enterModal.hide();

          // Open the second modal
          const drawModal = new bootstrap.Modal(drawEl);
          drawModal.show();
      });
  }
  
    /* -------------------------
       SHOW THANKYOU AFTER RELOAD
    -------------------------- */
    const url = new URL(window.location.href);

    // Detect Shopify's automatic contact flag
    if (url.searchParams.get("contact_posted") === "true" && window.location.hash === "#ContactForm-draw-entry") {
        const thankyou = document.getElementById("thankyouModal");
        if (thankyou) new bootstrap.Modal(thankyou).show();

        // Remove the parameter so modal doesn't show repeatedly
        url.searchParams.delete("contact_posted");
        window.history.replaceState({}, "", url.pathname);
    }
    document.querySelectorAll('.form-success, .form-error').forEach(msg => msg.classList.add('d-none'));

    // Check if Shopify redirected with success
    if (url.searchParams.get("contact_posted") === "true") {
      let targetTabBtn = null;
      // Check which form was submitted
      if (window.location.hash === "#ContactForm-general") {
          document.querySelector("#general-success")?.classList.remove("d-none");
          targetTabBtn = document.querySelector('#pills-tab-1');
      }

      if (window.location.hash === "#ContactForm-product-quality") {
          document.querySelector("#product-success")?.classList.remove("d-none");
          targetTabBtn = document.querySelector('#pills-tab-2');
      }

      // Activate the tab if found
      if (targetTabBtn) {
        const tab = new bootstrap.Tab(targetTabBtn);
        tab.show();
        // ✅ Scroll to title
        const titleEl = document.querySelector('.customer_feedback_title');
        if (titleEl) {
            titleEl.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
        }
      }

      return; // stop here — no error messages should show on success
    }

    // Check error case (Shopify redirects WITHOUT contact_posted)
    if (window.location.hash === "#ContactForm-general") {
        document.querySelector("#general-error")?.classList.remove("d-none");
    }

    if (window.location.hash === "#ContactForm-product-quality") {
        document.querySelector("#product-error")?.classList.remove("d-none");
    }

    /* -------------------------
       MULTI-STEP MODAL LOGIC
    -------------------------- */
    const popup = document.getElementById("drawPopup");
    if (!popup) return;

    const stepsWrapper = popup.querySelector(".steps_wrapper");
    const steps = [...popup.querySelectorAll(".common_step_class")];
    const nextBtn = popup.querySelector("#nextBtn");
    const backBtn = popup.querySelector("#backBtn");
    const pagination = popup.querySelector(".popup_pagination p");
    const form = popup.querySelector("form");

    let current = 0;
    const total = steps.length;
    /* -------------------------------------
        VALIDATION FUNCTION
    ------------------------------------- */
    steps.forEach(step => {
      const inputs = step.querySelectorAll("input, select");

      inputs.forEach(input => {
          input.addEventListener("input", () => {
              const msgBox = input.nextElementSibling;

              if (msgBox && msgBox.classList.contains("error-msg")) {
                  msgBox.textContent = "";
              }
              input.classList.remove("invalid-field");
          });
      });
    });

    function validateStep(stepIndex) {
      const fields = steps[stepIndex].querySelectorAll("input, select");
      let valid = true;

      fields.forEach(field => {

          // Remove old classes + messages
          field.classList.remove("invalid-field");

          let msgBox = field.nextElementSibling;
          if (msgBox && msgBox.classList.contains("error-msg")) {
              msgBox.textContent = "";
          }

          // Create message container if missing
          if (!msgBox || !msgBox.classList.contains("error-msg")) {
              msgBox = document.createElement("small");
              msgBox.classList.add("error-msg");
              field.insertAdjacentElement("afterend", msgBox);
          }

          // Required empty field
          if (field.hasAttribute("required") && !field.value.trim()) {
              valid = false;
              field.classList.add("invalid-field");
              msgBox.textContent = "This field is required.";
              return;
          }

          // Email validation
          if (field.type === "email" && field.value.trim()) {
              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              if (!emailRegex.test(field.value.trim())) {
                  valid = false;
                  field.classList.add("invalid-field");
                  msgBox.textContent = "Please enter a valid email.";
                  return;
              }
          }
      });

      return valid;
    }

    // Fix wrapper height
    const setHeight = () => {
        const heights = steps.map(step => {
            const clone = step.cloneNode(true);
            clone.style.display = "block";
            clone.style.visibility = "hidden";
            clone.style.position = "absolute";
            stepsWrapper.appendChild(clone);
            let h = clone.offsetHeight;
            clone.remove();
            return h;
        });

        stepsWrapper.style.minHeight = Math.max(...heights) + "px";
    };

    // const show = i => {
    //     steps.forEach((s, idx) => s.classList.toggle("active-step", idx === i));
    //     pagination.textContent = `${i + 1}/${total}`;
    //     nextBtn.textContent = i === total - 1 ? "Submit" : "Next";
    // };
    // ADDED BY KB
    const show = i => {
      steps.forEach((s, idx) => 
          s.classList.toggle("active-step", idx === i)
      );
      pagination.textContent = `${i + 1}/${total}`;
      nextBtn.textContent = i === total - 1 ? "Submit" : "Next";
      // Hide back button on first step
      backBtn.style.display = i === 0 ? "none" : "inline-block";
  };

    setHeight();
    show(current);

    nextBtn.addEventListener("click", e => {
      e.preventDefault();

      // Validate current step
      if (!validateStep(current)) {
          return; // Stop here if invalid
      }

      // Move to next step
      if (current < total - 1) {
          current++;
          show(current);
      } else {
        // LAST STEP → Validate everything → submit
        if (validateStep(current)) {
            // form.submit();
          const btn = nextBtn;
          const originalText = btn.innerText;
          btn.disabled = true;
          btn.innerText = "Submitting...";

          const formData = new FormData(form);
          const data = {};

          for (let [name, value] of formData.entries()) {
              if (name === "h-captcha-response" || name === 'utf8' || name === 'contact[attachment]') continue;
              const cleanName = name.replace(/^contact\[(.*)\]$/, '$1');
              data[cleanName] = value;
          }

          const zapierUrl = "https://hooks.zapier.com/hooks/catch/27122338/u7c44m8/";

          console.log('Draw form submitted data', data);

          fetch(zapierUrl, {
              method: "POST",
              mode: "no-cors",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(data)
          })
          .then(() => {
              form.submit();
          })
          .catch(err => {
              console.error("Zapier error:", err);
              btn.disabled = false;
              btn.innerText = originalText;
          });
        }
      }
    });

    // ADDED BY KB
    backBtn.addEventListener("click", e => {

      e.preventDefault();

      if (current > 0) {
          current--;
          show(current);
      }

  });

});
// Target the container so animation fires only when this section is visible =================
document.addEventListener('DOMContentLoaded', () => {
  try {
    const mainImage = document.querySelector('.gd_main_image');
    if (!mainImage) return; // exit quietly if not on this page

    const activate = () => mainImage.classList.add('gd_pop_active');

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            activate();
            obs.unobserve(entry.target); // run once
          }
        });
      }, { threshold: 0.3 });

      observer.observe(mainImage);
    } else {
      // Fallback for older browsers: trigger after a small delay
      setTimeout(activate, 300);
    }
  } catch (err) {
    // Fail silently in production; optionally log in dev
    // console.error('gd image animation error', err);
  }
});


// Animation : for "Meet the rest of The Quilton family" Section   
document.addEventListener('DOMContentLoaded', () => {
  const wrappers = Array.from(document.querySelectorAll('.swiper-wrapper'));

  if (!wrappers.length) return; // nothing to do

  const OBS_OPTIONS = {
    root: null,
    threshold: 0.25,         // change to taste (how much must be visible)
    rootMargin: '0px 0px -5% 0px'
  };

  const STAGGER_MS = 140;    // time between each image reveal
  const GLOBAL_DELAY = 0;    // initial delay before first image (ms)

  const wrapperObserver = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const wrapper = entry.target;

      // Select only reveal images inside THIS wrapper
      let imgs = Array.from(wrapper.querySelectorAll('.reveal-img'));

      // Remove any clones (swiper duplicates) so they don't double-animate
      imgs = imgs.filter(img => {
        const slide = img.closest('.swiper-slide');
        return !slide || !slide.classList.contains('swiper-slide-duplicate');
      });

      if (!imgs.length) {
        obs.unobserve(wrapper);
        return;
      }

      // Ensure starting hidden (in case CSS was overridden or HTML had .show)
      imgs.forEach(img => img.classList.remove('show'));

      // Staggered reveal
      imgs.forEach((img, i) => {
        const t = GLOBAL_DELAY + (i * STAGGER_MS);
        setTimeout(() => {
          img.classList.add('show');
        }, t);
      });

      obs.unobserve(wrapper); // run once
    });
  }, OBS_OPTIONS);

  // Observe only wrappers that actually contain reveal-img
  wrappers.forEach(w => {
    if (w.querySelector('.reveal-img')) wrapperObserver.observe(w);
  });
});


// Close Cart Drawer if open
window.closeCartDrawer = function () {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && cartDrawer.classList.contains('active')) {
    cartDrawer.close();
  }
};

// Close Header/Menu Drawer if open
window.closeHeaderDrawer = function () {
  const headerDrawer = document.querySelector('header-drawer');
  if (!headerDrawer) return;
  // Find the open summary
  const openSummary = headerDrawer.querySelector('summary[aria-expanded="true"]');
  if (!openSummary) return;
  // Close the drawer via Shopify's method
  headerDrawer.closeMenuDrawer(null, openSummary);
  // FIX: aria-expanded must be set to false manually
  openSummary.setAttribute('aria-expanded', 'false');
  // Remove animation class
  const menuToggle = headerDrawer.mainDetailsToggle || headerDrawer.querySelector('details');
  if (menuToggle) menuToggle.classList.remove('menu-opening');
};

// 

document.addEventListener("DOMContentLoaded", () => {

  function initMobileDropdowns() {
    const triggers = document.querySelectorAll(".list_item_has_submenu");

    triggers.forEach(trigger => {
      // Remove previous click handlers
      trigger.onclick = null;

      // Only for mobile (≤ 991px)
      if (window.innerWidth <= 991) {
        trigger.onclick = function(e) {
          e.preventDefault();

          const parentLi = trigger.closest("li");
          const submenu = parentLi.querySelector(".menu-drawer__submenu");
          if (!submenu) return;

          // Close other open submenus
          document.querySelectorAll(".menu-drawer__submenu.open").forEach(openSub => {
            if (openSub !== submenu) {
              openSub.classList.remove("open");
            }
          });

          // Toggle this submenu
          submenu.classList.toggle("open");
        };
      } else {
        // Desktop: remove class
        const parentLi = trigger.closest("li");
        const submenu = parentLi.querySelector(".menu-drawer__submenu");
        if (submenu) submenu.classList.remove("open");
      }
    });
  }

  // Initialize on DOM ready
  initMobileDropdowns();

  // Re-initialize on window resize
  window.addEventListener("resize", initMobileDropdowns);

});

// Product feedback form submission
const productQualityBtn = document.getElementById("ProductQualityFormSubmit");
  if (productQualityBtn) {
    productQualityBtn.addEventListener("click", function() {
    console.log('ProductQualityFormSubmit clicked');

    const form = document.getElementById("ContactForm-product-quality");

    // Run native HTML5 validation first
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const btn = this;
    const responseBox = document.getElementById("product-form-response");

    // Disable button + show loading
    btn.disabled = true;
    const originalText = btn.innerText;
    btn.innerText = "Submitting...";

    const formData = new FormData(form);
    const data = {};

    for (let [name, value] of formData.entries()) {
      if (name === "h-captcha-response" || name === 'utf8' || name === 'contact[attachment]') continue;
      const cleanName = name.replace(/^contact\[(.*)\]$/, '$1');
      data[cleanName] = value;
    }

    const zapierUrl = "https://hooks.zapier.com/hooks/catch/27122338/u71k9qo/";

    console.log('submitted data', data);

    // Step 1: Send to Zapier first
    fetch(zapierUrl, {
      method: "POST",
      mode: "no-cors",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    })
    .then(() => {
      // Step 2: On Zapier success, natively submit the form
      console.log("form submitted");
      form.submit();
    })
    .catch(err => {
      console.error("Zapier error:", err);
      responseBox.innerHTML = '<div class="text-danger">Something went wrong. Please try again.</div>';

      // Re-enable button on failure
      btn.disabled = false;
      btn.innerText = originalText;
    });
  });
}

// General Feedback form submission
const generalFormBtn = document.getElementById("GeneralContactFormSubmit");
  if(generalFormBtn){
    generalFormBtn.addEventListener("click", function() {
    console.log('GeneralContactFormSubmit clicked');

    const form = document.getElementById("ContactForm-general");

    // Run native HTML5 validation first
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const btn = this;
    const responseBox = document.getElementById("product-form-response");

    // Disable button + show loading
    btn.disabled = true;
    const originalText = btn.innerText;
    btn.innerText = "Submitting...";

    const formData = new FormData(form);
    const data = {};

    for (let [name, value] of formData.entries()) {
      if (name === "h-captcha-response" || name === 'utf8' || name === 'contact[attachment]') continue;
      const cleanName = name.replace(/^contact\[(.*)\]$/, '$1');
      data[cleanName] = value;
    }

    const zapierUrl = "https://hooks.zapier.com/hooks/catch/27122338/u713po8/";

    console.log('General Query submitted data', data);

    // Step 1: Send to Zapier first
    fetch(zapierUrl, {
      method: "POST",
      mode: "no-cors",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    })
    .then(() => {
      // Step 2: On Zapier success, natively submit the form
      form.submit();
    })
    .catch(err => {
      console.error("Zapier error:", err);

      // Re-enable button on failure
      btn.disabled = false;
      btn.innerText = originalText;
    });
  });
}
// Product single page subscription JS (Adds active class to parent when radio is checked)
// document.addEventListener("DOMContentLoaded", () => {
//   const planCard = document.querySelector(".plan_card");

//   if (!planCard) return;

//   const updateActiveClass = () => {
//     planCard.querySelectorAll(".subscription_group").forEach(group => {
//       const radio = group.querySelector('input[type="radio"]');

//       group.classList.toggle("active", radio?.checked);
//     });
//   };
//   // Initial active state
//   updateActiveClass();

//   // Event delegation (optimized)
//   planCard.addEventListener("change", (e) => {
//     if (e.target.matches('input[type="radio"]')) {
//       updateActiveClass();
//     }
//   });
// });

function initSubscriptionGroups() {
  const planCard = document.querySelector(".plan_card");

  if (!planCard || planCard.dataset.initialized) return;

  planCard.dataset.initialized = "true";

  const updateActiveClass = () => {
    planCard.querySelectorAll(".subscription_group").forEach(group => {
      const radio = group.querySelector('input[type="radio"]');

      group.classList.toggle("active", radio?.checked);
    });
  };

  // Initial state
  updateActiveClass();

  // Change event
  planCard.addEventListener("change", (e) => {
    if (e.target.matches('input[type="radio"]')) {
      updateActiveClass();
    }
  });
}

// Initial load
document.addEventListener("DOMContentLoaded", () => {
  initSubscriptionGroups();

  // Watch for Shopify app re-render
  const observer = new MutationObserver(() => {
    initSubscriptionGroups();

    // Re-apply active state after render
    document.querySelectorAll(".plan_card").forEach(card => {
      card.querySelectorAll(".subscription_group").forEach(group => {
        const radio = group.querySelector('input[type="radio"]');

        group.classList.toggle("active", radio?.checked);
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
